<template>
    <ul class="fd-tab-list">
        <li v-for="item in tabList"
            @click="change(item)"
            @mouseover="mouseenter(item)"
            :class="{'js-active':curActive ===item.code}"
            :key="item.code">{{ item.name }}
        </li>
        <li v-if="hasMore" @click="goToMore" class="fd-more">查看更多</li>
    </ul>
</template>

<script>
export default {
    name: 'tab',
    props: {

        /**
         * #property
         *
         * @name    tabList
         * @type    object
         * @description 当前的所有tab切换数据
         */
        tabList: {
            type: Array,
            required: true
        },

        /**
         * #property
         *
         * @name    tabList
         * @type    object
         * @description 使用hover时间还是点击事件修改选中项
         */
        useOver: {
            type: Boolean,
            default:false
        },

        /**
         * #property
         *
         * @name    active
         * @type    String
         * @description 当前选中的item
         */
        active: {
            type: String,
            default: function () {
                return {};
            }
        },

        /**
         * #property
         *
         * @name    hasMore
         * @type    Boolean
         * @description 是否有查看更多
         */
        hasMore: {
            type: Boolean,
            default: false
        },

        /**
         * #property
         *
         * @name    moreDetail
         * @type    Object
         * @description 跳转更多页面的信息
         */
        moreDetail: {
            type: Object,
            default: function () {
                return {};
            }
        },

        /**
         * #property
         *
         * @name    keepChange
         * @type    Boolean
         * @description 是否需要记住选中项
         */
        keepChange:{
            type: Boolean,
            default:true
        }
    },
    data() {
        return {curActive: ''};
    },
    watch: {
        active: {
            handler(newVal) {
                this.curActive = this.$route.query.tab || newVal;
            },
            immediate: true
        }
    },
    mounted() {
        if (this.$route.query.tab && this.keepChange) {
            const current = this.tabList.find((item) => item.code === this.$route.query.tab);
            this.change(current);
        }
    },
    methods: {
        change(item) {
            // 判断点亮的选项是否修改
            if (this.curActive !== item.code) {
                this.curActive = item.code;
                if (this.keepChange) {
                    const query = {tab:item.code};
                    if (item.code === 'fyjs') {
                        query.code = this.$route.query ? this.$route.query.code : '';
                    }
                    this.$router.push({query: query});
                }
                this.$emit('change', this.curActive, item);
            }
        },
        mouseenter(item) {
            // 判断是否是使用鼠标移入事件切换，并且点亮的选项是否修改
            if (this.useOver && this.curActive !== item.code) {
                this.curActive = item.code;
                this.$emit('tabover', this.curActive, item);
            }
        },
        goToMore() {
            this.$router.push(this.moreDetail);
        }
    }
};
</script>

<style lang="less" scoped>
@import "~@/css/config/config.less";

.fd-tab-list {
    position: relative;
    display: flex;
    color: @text-color;
    font-size: 18px;
    line-height: 24px;

    &::after {
        content: "";
        position: absolute;
        bottom: 3px;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: fade(@text-color, 20);
    }

    li {
        position: relative;
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
        color: @text-color;
        cursor: pointer;
        font-size: 18px;
        line-height: 24px;

        &.fd-more {
            position: absolute;
            right: 0;
            margin-right: 0;
            padding-right: 16px;
            color: #3d7fff;
            font-size: 14px;
            font-weight: normal;
            cursor: pointer;
            background: url("~@/images/sy/icon-more.png") right center no-repeat;
        }

        &.js-active {
            color: @blue-color;
            font-weight: bold;

            &::before {
                content: "";
                position: absolute;
                bottom: 3px;
                left: 0;
                width: 100%;
                height: 2px;
                background-color: @blue-color;
            }

            &::after {
                content: "";
                position: absolute;
                bottom: -2px;
                left: calc(50% - 3px);
                border-color: @blue-color transparent transparent transparent;
                border-style: solid;
                border-width: 3px;
            }
        }

        &:hover {
            color: @blue-color;
            font-weight: bold;
        }
    }
}
</style>
